"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1887],{

/***/ 61659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const ClickOutside = (param)=>{
    let { children , clickHandler  } = param;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handleClick = (event)=>{
        if (ref.current && !ref.current.contains(event.target)) {
            clickHandler();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.addEventListener("click", handleClick);
        return ()=>{
            document.removeEventListener("click", handleClick);
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickOutside);


/***/ }),

/***/ 84659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./redux/Frontend/ListingsFilter/redux/slice.tsx
var slice = __webpack_require__(2576);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-daterange-picker/dist/DateRangePicker.js
var DateRangePicker = __webpack_require__(63784);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/moment-range/dist/moment-range.js
var moment_range = __webpack_require__(23542);
// EXTERNAL MODULE: ./redux/Frontend/ListingsFilter/redux/selector.tsx
var selector = __webpack_require__(76721);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
;// CONCATENATED MODULE: ./components/UI/FilterDate.tsx









//@ts-ignore
const FilterDate_moment = (0,moment_range.extendMoment)((moment_default()));
function FilterDate(param) {
    let { customDate , _showCalender , showCalender , _handleRetreatDate , filterData , customDateSuggestion  } = param;
    var _moment;
    const router = (0,next_router.useRouter)();
    const today = FilterDate_moment();
    const listingForm = (0,es/* useSelector */.v9)(selector/* SelectListingForm */.lm);
    const [selectedDate, setSelectedDate] = (0,react.useState)(today);
    const [activetab, setActiveTab] = (0,react.useState)("No Dates");
    const dispatch = (0,es/* useDispatch */.I0)();
    const _handletab = (value)=>{
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "date",
            value: ""
        }));
        setActiveTab(value);
        _showCalender();
        _handleRetreatDate("");
    };
    const _handleDisplayDate = (val)=>{
        if (val.length > 0) dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "date",
            value: val
        }));
    };
    const onSelectRange = (value)=>{
        const date = "".concat(FilterDate_moment(value).format());
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "date",
            value: date
        }));
        _handleRetreatDate(FilterDate_moment(value).format());
        _showCalender();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(customDate, "  d-flex custom-date "),
            children: [
                showCalender && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "search-component-suggestion bg-white p-3 text-center ".concat(customDateSuggestion),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-column byr-category-button-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-row justify-content-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "".concat(activetab == "Specific Dates" ? "btn-outline-primary-active" : "btn-outline-primary btnHoverNew", " py-2 btn fs-12 shadow-none btnHover"),
                                        onClick: ()=>setActiveTab("Specific Dates"),
                                        style: {
                                            width: "120px",
                                            borderTopRightRadius: "unset",
                                            borderBottomRightRadius: "unset"
                                        },
                                        children: "Specific Dates"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "".concat(activetab != "No Dates" ? "btn-outline-primary btnHoverNew" : "btn-outline-primary-active", "  py-2 btn fs-12 shadow-none btnHover "),
                                        style: {
                                            width: "120px",
                                            borderTopLeftRadius: "unset",
                                            borderBottomLeftRadius: "unset"
                                        },
                                        onClick: ()=>_handletab("No Dates"),
                                        children: "No Dates"
                                    })
                                ]
                            }),
                            activetab == "No Dates" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex flex-wrap py-3 justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fs-12 m-0",
                                    children: "No dates selected,showing retreats for all dates"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2",
                                children: showCalender && /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangePicker/* default */.Z, {
                                    selectionType: "single",
                                    value: listingForm === null || listingForm === void 0 ? void 0 : listingForm.date,
                                    onSelect: onSelectRange,
                                    minimumDate: new Date()
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 d-flex flex-row align-items-center justify-content-start px-md-3 px-3 py-2 pointer",
                    onClick: _showCalender,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/calendar-icon.svg",
                            className: "img-fluid",
                            height: "14px",
                            width: "14px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            placeholder: "Select Date",
                            value: (listingForm === null || listingForm === void 0 ? void 0 : listingForm.date.length) > 0 ? (_moment = FilterDate_moment(listingForm === null || listingForm === void 0 ? void 0 : listingForm.date)) === null || _moment === void 0 ? void 0 : _moment.format("DD/MM/YYYY") : "",
                            onChange: ()=>_handleDisplayDate(listingForm.date),
                            className: "col-10 fs-12 fw-500 px-0 border-0 rounded-0 mx-2 pointer"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var UI_FilterDate = (FilterDate);

// EXTERNAL MODULE: ./components/Admin/ClickOutside.tsx
var ClickOutside = __webpack_require__(61659);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./components/UI/CustomToast.tsx
var CustomToast = __webpack_require__(48509);
;// CONCATENATED MODULE: ./components/UI/Search.tsx











function Search(props) {
    var _searchLog_search, _searchLog_activity, _searchLog_listings, _searchLog_locations, _searchLog_search1, _searchLog_listings1, _searchLog_locations1, _searchLog_locations2, _searchLog_listings2, _searchLog_defaultSearch;
    const router = (0,next_router.useRouter)();
    const city = router.query.city;
    const country = router.query.country;
    const { filterData , _handleChange , customSearch , customDate , customButton , customSearchSuggesion , customDateSuggestion , children  } = props;
    const [isSearch, setIsSeach] = (0,react.useState)(false);
    const [pageNumber, setPageNumber] = (0,react.useState)(1);
    const [searchName, setSearchName] = (0,react.useState)("");
    const [popularLoading, setPopularLoading] = (0,react.useState)(false);
    const [showPopular, setShowPopular] = (0,react.useState)(false);
    const [showCalender, setshowCalender] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [retreatDate, setretreatDate] = (0,react.useState)([]);
    const [filteredSearchData, setFilteredSearchData] = (0,react.useState)([]);
    const _showCalender = ()=>{
        setshowCalender(!showCalender);
        setShowPopular(false);
        setIsSeach(false);
    };
    const _showPopular = ()=>{
        setshowCalender(false);
        setShowPopular(!showPopular);
        setIsSeach(false);
        setPopularLoading(true);
    };
    const listingForm = (0,es/* useSelector */.v9)(selector/* SelectListingForm */.lm);
    const searchLog = (0,es/* useSelector */.v9)(selector/* SelectSearchLog */.n9);
    (0,react.useEffect)(()=>{
        if ((city === null || city === void 0 ? void 0 : city.length) == 0 && (country === null || country === void 0 ? void 0 : country.length) == 0) {
            dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                key: "country",
                value: ""
            }));
            dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                key: "city",
                value: ""
            }));
        }
        setretreatDate(listingForm.date);
    }, [
        listingForm.date,
        city,
        country
    ]);
    const _handleRetreatDate = (date)=>{
        setretreatDate(date);
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "date",
            value: date
        }));
        _handleChange({});
    };
    // const { loading, error, hasMore, searchData } = useSearchRetreats(
    //   pageNumber,
    //   searchName,
    //   isSearch
    // );
    // useEffect(() => {
    //   setFilteredSearchData(searchData);
    // }, [searchData]);
    const observer = react.useRef();
    (0,react.useEffect)(()=>{
        dispatch(slice/* actions.DoGetSearchLogList */.Nw.DoGetSearchLogList());
    }, [
        showPopular
    ]);
    // ---------------------------------------------------------------------------------------------------------------
    let regex = /^[A-Za-z0-9\s]*$/;
    const handleOnSearch = (e)=>{
        setPageNumber(1);
        const { value , name  } = e.target;
        if (value.trim().length > 0) {
            if (regex.test(value)) {
                dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                    key: "search",
                    value: value
                }));
                dispatch(slice/* actions.setsearchlogsearch */.Nw.setsearchlogsearch(value.trim()));
            }
        } else {
            dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                key: "search",
                value: value
            }));
            dispatch(slice/* actions.setsearchlogsearch */.Nw.setsearchlogsearch(value.trim()));
        }
        // _handleChange({});
        if (value.length >= 1) {
            setIsSeach(true);
        } else {
            setIsSeach(false);
        }
    };
    const searhlogsearch = (0,es/* useSelector */.v9)(selector/* SelectSearchLogSearch */.Pj);
    (0,react.useEffect)(()=>{
        dispatch(slice/* actions.DoGetSearchLogList */.Nw.DoGetSearchLogList());
    }, [
        searhlogsearch
    ]);
    const [redirectName, setRedirectName] = (0,react.useState)("");
    const [cityValue, setCityValue] = (0,react.useState)("");
    const restreatSearch = ()=>{
        setIsSeach(false);
        setShowPopular(false);
        setshowCalender(false);
        if (listingForm.search == "" && listingForm.city == "" && (listingForm === null || listingForm === void 0 ? void 0 : listingForm.date) == "" && //@ts-ignore
        (listingForm === null || listingForm === void 0 ? void 0 : listingForm.activityFilter) == []) {
            (0,CustomToast/* default */.Z)("Please fill the data", "ERROR");
            return;
        } else {
            router.push({
                pathname: "/listing",
                query: {
                    ...listingForm
                }
            });
            if (redirectName == "search") {
                router.push({
                    pathname: "/listing",
                    query: {
                        ...listingForm
                    }
                });
            // dispatch(actions.clearSearch());
            } else if (redirectName == "location") {
                router.push({
                    pathname: "/listing",
                    query: {
                        ...listingForm
                    }
                });
                dispatch(slice/* actions.clearSearch */.Nw.clearSearch());
                dispatch(slice/* actions.clearLocationFilterForm */.Nw.clearLocationFilterForm({
                    callback () {}
                }));
            } else if (redirectName == "activity") {
                router.push({
                    pathname: "/listing",
                    query: {
                        ...listingForm
                    }
                });
                dispatch(slice/* actions.clearSearch */.Nw.clearSearch());
            }
        }
    };
    const handleSearch = (e, name)=>{
        if (name == "location") {
            setRedirectName(name);
            setCityValue(e.target.textContent);
            const string_value = e.target.textContent;
            const split_values = string_value.split(",");
            dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                key: "country",
                value: split_values[1]
            }));
            dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                key: "city",
                value: split_values[0]
            }));
            dispatch(slice/* actions.clearSearch */.Nw.clearSearch());
            dispatch(slice/* actions.clearActivitySearch */.Nw.clearActivitySearch());
        } else if (name == "activity") {
            setRedirectName(name);
            dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                key: "activityFilter",
                value: e.target.textContent
            }));
            dispatch(slice/* actions.clearSearch */.Nw.clearSearch());
            dispatch(slice/* actions.clearLocationFilterForm */.Nw.clearLocationFilterForm({
                callback () {}
            }));
        } else if (name == "search") {
            setRedirectName(name);
            dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
                key: "search",
                value: e.target.textContent
            }));
            dispatch(slice/* actions.clearLocationFilterForm */.Nw.clearLocationFilterForm({
                callback () {}
            }));
            dispatch(slice/* actions.clearActivitySearch */.Nw.clearActivitySearch());
        }
        setShowPopular(false);
    };
    const handleClickClose = ()=>{
        setshowCalender(false);
        setShowPopular(false);
        setIsSeach(false);
        setPopularLoading(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickOutside/* default */.Z, {
        clickHandler: handleClickClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " search",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex flex-column flex-md-row justify-content-between px-0 col-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(customSearch, " d-flex py-1 custom_search"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-2 d-flex align-items-center justify-content-center bg-white ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/search.svg",
                                    className: "mx-1",
                                    height: "18",
                                    width: "18"
                                })
                            }),
                            redirectName == "search" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "You are about to find the best yoga experience",
                                "aria-label": "retreat",
                                "aria-describedby": "basic-addon1",
                                onChange: (e)=>handleOnSearch(e),
                                onClick: _showPopular,
                                value: listingForm.search,
                                className: "col-10 fs-12 fw-500 px-0 border-0 rounded-0 py-2"
                            }) : redirectName == "location" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "You are about to find the best yoga experience",
                                "aria-label": "retreat",
                                "aria-describedby": "basic-addon1",
                                onChange: (e)=>handleOnSearch(e),
                                onClick: _showPopular,
                                value: cityValue,
                                className: "col-10 fs-12 fw-500 px-0 border-0 rounded-0 py-2"
                            }) : redirectName == "activity" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "You are about to find the best yoga experience",
                                "aria-label": "retreat",
                                "aria-describedby": "basic-addon1",
                                onChange: (e)=>handleOnSearch(e),
                                onClick: _showPopular,
                                value: listingForm.activityFilter,
                                className: "col-10 fs-12 fw-500 px-0 border-0 rounded-0 py-2"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "You are about to find the best yoga experience",
                                "aria-label": "retreat",
                                "aria-describedby": "basic-addon1",
                                onChange: (e)=>handleOnSearch(e),
                                onClick: _showPopular,
                                value: listingForm.search,
                                className: "col-10 fs-12 fw-500 px-0 border-0 rounded-0 py-2"
                            })
                        ]
                    }),
                    showPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(customSearchSuggesion, " search-component-suggestion bg-white"),
                        style: {
                            zIndex: 9999
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "height",
                            children: (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_search = searchLog.search) === null || _searchLog_search === void 0 ? void 0 : _searchLog_search.length) > 0 || (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_activity = searchLog.activity) === null || _searchLog_activity === void 0 ? void 0 : _searchLog_activity.length) > 0 || (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_listings = searchLog.listings) === null || _searchLog_listings === void 0 ? void 0 : _searchLog_listings.length) > 0 || (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_locations = searchLog.locations) === null || _searchLog_locations === void 0 ? void 0 : _searchLog_locations.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: listingForm.search.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_search1 = searchLog.search) === null || _searchLog_search1 === void 0 ? void 0 : _searchLog_search1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-12 fw-bold my-2 mx-3",
                                                    children: "Popular Searches"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-2"
                                                }),
                                                searchLog === null || searchLog === void 0 ? void 0 : searchLog.search.map((data, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "data-row ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "fs-12 my-1 mx-3 pointer",
                                                                onClick: (e)=>handleSearch(e, "search"),
                                                                children: data === null || data === void 0 ? void 0 : data.searchKeyword
                                                            })
                                                        }, index)
                                                    });
                                                })
                                            ]
                                        }),
                                        (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_listings1 = searchLog.listings) === null || _searchLog_listings1 === void 0 ? void 0 : _searchLog_listings1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-12 fw-bold my-2 mx-3",
                                                    children: "listings"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-2"
                                                }),
                                                searchLog === null || searchLog === void 0 ? void 0 : searchLog.listings.map((data, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "data-row ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "fs-12 my-1 mx-3 pointer",
                                                                onClick: (e)=>handleSearch(e, "search"),
                                                                children: data === null || data === void 0 ? void 0 : data.retreatTitle
                                                            })
                                                        }, index)
                                                    });
                                                })
                                            ]
                                        }),
                                        (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_locations1 = searchLog.locations) === null || _searchLog_locations1 === void 0 ? void 0 : _searchLog_locations1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-12 fw-bold my-2 mx-3",
                                                    children: "Destinations:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-2"
                                                }),
                                                searchLog === null || searchLog === void 0 ? void 0 : searchLog.locations.map((data, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "data-row ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "fs-12 my-1 mx-3 pointer",
                                                                onClick: (e)=>handleSearch(e, "location"),
                                                                children: [
                                                                    data === null || data === void 0 ? void 0 : data.city,
                                                                    ",",
                                                                    data === null || data === void 0 ? void 0 : data.country
                                                                ]
                                                            })
                                                        }, index)
                                                    });
                                                })
                                            ]
                                        }),
                                        searchLog.activity.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-12 fw-bold my-2 mx-3",
                                                    children: "Categories:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-2"
                                                }),
                                                searchLog === null || searchLog === void 0 ? void 0 : searchLog.activity.map((data, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "data-row ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "fs-12 my-1 mx-3 pointer",
                                                                onClick: (e)=>handleSearch(e, "activity"),
                                                                children: data === null || data === void 0 ? void 0 : data.name
                                                            })
                                                        }, index)
                                                    });
                                                })
                                            ]
                                        })
                                    ]
                                }) : listingForm.search.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_locations2 = searchLog.locations) === null || _searchLog_locations2 === void 0 ? void 0 : _searchLog_locations2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-12 fw-bold my-2 mx-3",
                                                    children: "Destinations:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-2"
                                                }),
                                                searchLog === null || searchLog === void 0 ? void 0 : searchLog.locations.map((data, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "data-row ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "fs-12 my-1 mx-3 pointer",
                                                                onClick: (e)=>handleSearch(e, "location"),
                                                                children: [
                                                                    data === null || data === void 0 ? void 0 : data.city,
                                                                    ",",
                                                                    data === null || data === void 0 ? void 0 : data.country
                                                                ]
                                                            })
                                                        }, index)
                                                    });
                                                })
                                            ]
                                        }),
                                        (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_listings2 = searchLog.listings) === null || _searchLog_listings2 === void 0 ? void 0 : _searchLog_listings2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-12 fw-bold my-2 mx-3",
                                                    children: "listings:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-2"
                                                }),
                                                searchLog === null || searchLog === void 0 ? void 0 : searchLog.listings.map((data, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "data-row ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "fs-12 my-1 mx-3 pointer",
                                                                onClick: (e)=>handleSearch(e, "search"),
                                                                children: data === null || data === void 0 ? void 0 : data.retreatTitle
                                                            })
                                                        }, index)
                                                    });
                                                })
                                            ]
                                        }),
                                        searchLog.activity.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-12 fw-bold my-2 mx-3",
                                                    children: "Categories:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-2"
                                                }),
                                                searchLog === null || searchLog === void 0 ? void 0 : searchLog.activity.map((data, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "data-row ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "fs-12 my-1 mx-3 pointer",
                                                                onClick: (e)=>handleSearch(e, "activity"),
                                                                children: data === null || data === void 0 ? void 0 : data.name
                                                            })
                                                        }, index)
                                                    });
                                                })
                                            ]
                                        })
                                    ]
                                }) : ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center mt-3 pb-3 fs-11",
                                        children: "We‘re sorry. We cannot find any matches for your search term."
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "my-2"
                                    }),
                                    (searchLog === null || searchLog === void 0 ? void 0 : (_searchLog_defaultSearch = searchLog.defaultSearch) === null || _searchLog_defaultSearch === void 0 ? void 0 : _searchLog_defaultSearch.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "fs-12 fw-bold my-2 mx-3",
                                                children: "Popular Searches"
                                            }),
                                            searchLog === null || searchLog === void 0 ? void 0 : searchLog.defaultSearch.map((data, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "data-row ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "fs-12 my-1 mx-3 pointer",
                                                            onClick: (e)=>handleSearch(e, "search"),
                                                            children: data === null || data === void 0 ? void 0 : data.searchKeyword
                                                        })
                                                    }, index)
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_FilterDate, {
                        customDate: customDate,
                        filterData: filterData,
                        _showCalender: _showCalender,
                        showCalender: showCalender,
                        _handleRetreatDate: _handleRetreatDate,
                        restreatSearch: restreatSearch,
                        customDateSuggestion: customDateSuggestion
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(customButton, "  d-flex justify-content-between "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "d-flex fw-500 align-items-center justify-content-center bg-dark-blue text-white w-100 fs-12 px-2 search-btn b-none py-3 py-md-0 search-button-width",
                                onClick: restreatSearch,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                                        height: "15px",
                                        width: "15px",
                                        className: "img-fluid me-2"
                                    }),
                                    "Discover Now"
                                ]
                            }),
                            children
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var UI_Search = (Search);


/***/ }),

/***/ 30283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41248);
/* harmony import */ var react_currency_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95340);
/* harmony import */ var react_currency_format__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_currency_format__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _redux_School_SchoolPayments_redux_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4657);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81923);






const currencyshow = (param)=>{
    let { type , value , className , style  } = param;
    const [currency, setCurrency] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("USD");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (getCookie("currencyType").length > 0) {
            setCurrency(getCookie("currencyType"));
        }
    }, []);
    const Currencies = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_School_SchoolPayments_redux_selector__WEBPACK_IMPORTED_MODULE_4__/* .selectAllActiveCurrencyListData */ .IF);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_5__/* .log */ .c)("Currencies", Currencies);
        return ()=>{};
    }, [
        Currencies
    ]);
    const renderCurrencySymbol = ()=>{
        const val = Currencies.filter((x)=>x.code == currency);
        if (val.length > 0) {
            return val[0].symbol;
        } else {
            return "$";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: className,
        style: {
            ...style
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_currency_format__WEBPACK_IMPORTED_MODULE_3___default()), {
            value: value,
            displayType: "text",
            thousandSeparator: true,
            prefix: renderCurrencySymbol() + " "
        })
    });
};
const getCookie = (cname)=>{
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " "){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};
/* harmony default export */ __webpack_exports__["Z"] = (currencyshow);


/***/ })

}]);